import { Box, Container, Grid2 } from "@mui/material";
import { PageTitle } from "../../../commanComponents/PageTitle";
import { LinearProgressBar } from "../../../commanComponents/LinearProgressBar";
import { String } from "../../../constants/Strings";

import { getColor } from "../../../style/color/color";
import { useContext, useEffect, useState } from "react";
import ACRButton from "../../../commanComponents/ACRButton";
import { useNavigate } from "react-router-dom";
import {
  AcrButton,
  CardText,
  StyledButton,
  StyledCard,
  StyledCardBox,
  StyledContainer,
  StyledContent,
  StyledQuestion,
} from "../../../style/styleComponents/StyledSecondInning";
import { DataContext } from "../../../Hooks/context/ChildData";
import CustomSnackbar from "../../../commanComponents/CustomerSnackbar";
import { useLocalStorage } from "../../../logic/LocalStorage/LocalStorage";
import { AuthContext } from "../../../Hooks/context/AuthContext";
import { useSavingGoals } from "../../../api/apiEndpoints/SavingGoals";
import { RetirementCards } from "../../../constants/RetirementsCardArray";
import { gaCustomEvent } from "../../../logic/CommonFunctions";
import { OTPVerifyContext } from "../../../Hooks/context/OTPVeriryContext";

// Card component for displaying lifestyle choices
const Card = ({ card, index, selectedCardIndex, onClick }) => (
  <StyledCard
    selected={selectedCardIndex === index}
    onClick={() => onClick(index)}
  >
    <Box
      sx={{
        backgroundColor: getColor.ExtendedPalettesSummerSkySS100,
        p: "8px",
        borderRadius: 2,
        mt: "10px",
      }}
    >
      <card.image
        style={{
          width: "50px",
          height: "50px",
          borderRadius: 6,
          margin: "4px",
        }}
      />
    </Box>
    <CardText selectedCardIndex={selectedCardIndex === index}>
      {card.text}
    </CardText>
  </StyledCard>
);
const RetirementGoal = () => {
  const [selectedCardIndex, setSelectedCardIndex] = useState(null);
  const [selectedCard, setSelectedCard] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarmessage, setSnackbarMessage] = useState({
    message: "",
    severity: "",
  });
  const navigation = useNavigate();
  const { collectedData, collectData } = useContext(DataContext);
  const { verifyData } = useContext(OTPVerifyContext);
  const { saveLocalFinancialData, retrieveLocalFinancialData } =
    useLocalStorage();
  const { saveGoals } = useSavingGoals();
  const { authTokens } = useContext(AuthContext);

  const { userId } = authTokens;

  const { Title, question1 } = String.Retirement.SecondInning;

  const onHandleClick = (index, card) => {
    gaCustomEvent(String.gaEventName.acrPortfolio, String.gaEventClickName.acrPortfolioRetirementGoal, verifyData.customerId);

    setSelectedCardIndex(index);
    if (card === "Current Comfort") {
      setSelectedCard("Maintain Status Quo");
    } else {
      setSelectedCard(card);
    }
  };

  // Load previously selected lifestyle from local storage
  useEffect(() => {
    const retrieveSavedData = async () => {
      try {
        const data = await retrieveLocalFinancialData(
          `retirementgoal-${userId}`
        );

        if (data) {
          setSelectedCardIndex(data.selectedCardIndex);
          setSelectedCard(data.selectedCard);
        } else {
          setSelectedCard(null);
        }
      } catch (e) {}
    };
    retrieveSavedData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const showSnackbar = (message, severity) => {
    setSnackbarMessage({ message, severity });
    setSnackbarOpen(true);
  };

  // Handle continue and save goal
  const handleContineu = async () => {
    gaCustomEvent(String.gaEventName.acrPortfolio, String.gaEventClickName.acrPortfolioRetirementGoalContinue, verifyData.customerId);
    if (selectedCard !== "" && !selectedCard) {
      showSnackbar(
        String.Retirement.SecondInning.selectGoal,
        String.ErrorSeverity
      );
      return;
    }
    //save locally
    saveLocalFinancialData(`retirementgoal-${userId}`, {
      selectedCard,
      selectedCardIndex,
    });

    collectData({ ...collectedData, selectedCard: selectedCard });
    try {
      const data = {
        userId: userId,
        isParent: collectedData.isParent || false,
        idealRetirement: selectedCard,
        children: collectedData.children ? collectedData.children : [],
        dependants: collectedData.dependants ? collectedData.dependants : [],
        goals: [...(collectedData.selectedGoals || [])],
      };
      // Save to backend only if goal 5 is selected
      if (collectedData.selectedGoals.includes(5)) {
        const response = await saveGoals(data);
        if (response.httpCode === 200) {
          showSnackbar(
            String.successMessageforGoalsave,
            String.successSeverity
          );
          // Navigate based on selected goals
          setTimeout(() => {
            if (collectedData.selectedGoals.includes(4)) {
              navigation(String.navigations.investmentgoal);
            } else {
              navigation(String.navigations.fetchinfo);
            }
          }, 500);
        }
      } else {
      }
    } catch (error) {
      showSnackbar(String.errorMessageforGoalsave, String.ErrorSeverity);
    }
  };
  return (
    <StyledContainer>
      <Container sx={{ flexGrow: 1 }}>
        <PageTitle PageTitle={Title} />
        <LinearProgressBar
          dragMessage={String.Retirement.dragMessage}
          progress={44}
          progressNumber={44}
          stepNumber={2}
        />
      </Container>
      <Box sx={{ textAlign: "center" }}>
        <StyledQuestion>{question1}</StyledQuestion>
      </Box>
      <StyledCardBox>
        <Grid2 container spacing={1}>
          {RetirementCards.map((card, index) => (
            <Grid2 item xs={4} key={index}>
              <Card
                card={card}
                index={index}
                selectedCardIndex={selectedCardIndex}
                onClick={() => onHandleClick(index, card.text)}
              />
            </Grid2>
          ))}
          <Box sx={{ mt: 2, textAlign: "center", width: "100%" }}>
            {selectedCardIndex !== null && (
              <StyledContent>
                {RetirementCards[selectedCardIndex].description}{" "}
              </StyledContent>
            )}
          </Box>
        </Grid2>
      </StyledCardBox>

      <StyledButton>
        <ACRButton
          label={String.continue}
          onClickButton={handleContineu}
          style={AcrButton}
          disabled={selectedCardIndex === null}
        />
      </StyledButton>
      <CustomSnackbar
        open={snackbarOpen}
        handleClose={() => setSnackbarOpen(false)}
        severity={snackbarmessage.severity}
        message={snackbarmessage.message}
      />
    </StyledContainer>
  );
};

export default RetirementGoal;
